import type { AnyFormApi } from '@tanstack/react-form';
import type { ZodIssue } from 'zod';

export type ValidationResponsePayload = {
  success: false;
  message: string;
  fieldErrors?: ZodIssue[];
  formErrors?: string[];
};

export function mapErrorResponseIntoForm(
  response: ValidationResponsePayload | undefined,
  formApi: AnyFormApi,
): void {
  if (!response) return;
  response.fieldErrors?.forEach(error => {
    if (error.path.length !== 1) {
      return; // Not supported yet
    }

    const field = String(error.path[0]);

    formApi.setFieldMeta(field, prev => ({
      ...prev,
      errorMap: {
        onServer: { message: error.message },
      },
      errors: [{ message: error.message }],
    }));
  });

  if (response.formErrors?.length) {
    const errors = response.formErrors?.map(e => ({ message: e })) ?? [];
    formApi.baseStore.setState(prev => ({
      ...prev,
      errors,
      errorMap: {
        ...prev.errorMap,
        onServer: errors.map(({ message }) => message).join(', '),
      },
    }));
  }
}
